<!--
    高级编辑器-右侧资源部分
    作用：提供课件资源获取；
    实现：展现数据，加载数据；
    组件：
        import {mapState, mapActions} from 'vuex'
        import Moshi from './components/moshi'
        import Changjing from './components/changjing'
        import Wenzi from './components/wenzi'
        import Tupian from './components/tupian'
        import Yinpin from './components/yinpin'
        import Donghua from './components/donghua'
        import Shipin from './components/shipin'
        import Youxi from './components/youxi'
        import Tools from './components/tools'
        import QuestionBank from './components/questionBank'
        import More from './components/more'
        import GuideBox from './components/guideBox'
        import { AudioPause } from "../../../../utils/audio";
    注释：WJ
-->
<template>
    <div
        class="types-box"
        :class="{'deep-black': true}"
        @click="handleMouseEnterOpen"
    >
        <div class="types">
            <p @click="changeType(typeEnums[2])" class="item wenzi" :class="{'active': select === typeEnums[2]}">
                <img :src="$images.menuType.word" alt="img" />
                <span>文字</span>
            </p>
            <p @click="changeType(typeEnums[3])" class="item tupian" :class="{'active': select === typeEnums[3]}">
                <img :src="$images.menuType.image" alt="img" />
                <span>图片</span>
            </p>
            <p @click="changeType(typeEnums[5])" class="item donghua" :class="{'active': select === typeEnums[5]}">
                <img :src="$images.menuType.animate" alt="img" />
                <img :src="$images.menuType.hot" alt="hot" class="hot" />
                <span>动画</span>
            </p>
            <p @click="changeType(typeEnums[4])" class="item yinpin" :class="{'active': select === typeEnums[4]}">
                <img :src="$images.menuType.music" alt="img" />
                <span>音频</span>
            </p>
            <p @click="changeType(typeEnums[6])" class="item shiping" :class="{'active': select === typeEnums[6]}">
                <img :src="$images.menuType.video" alt="img" />
                <span>视频</span>
            </p>
            <p @click="changeType(typeEnums[10])" class="item youxi" :class="{'active': select === typeEnums[10]}">
                <img :src="$images.menuType.tool" alt="img" />
                <span>工具</span>
            </p>
            <p @click="changeType(typeEnums[7])" class="item youxi" :class="{'active': select === typeEnums[7]}">
                <img :src="$images.menuType.game" alt="img" />
                <span>游戏</span>
            </p>
            <p @click="changeType(typeEnums[0])" class="item moshi" :class="{'active': select === typeEnums[0]}">
                <img :src="$images.menuType.template" alt="img" />
                <span>模版</span>
            </p>
            <!--p @click="changeType(typeEnums[1])" class="item changjing" :class="{'active': select === typeEnums[1]}">
                <img :src="$images.menuType.scene" alt="img" />
                <span>场景</span>
            </p-->
            <p @click="changeType(typeEnums[11])" class="item youxi" :class="{'active': select === typeEnums[11]}">
                <img :src="$images.menuType.questionbank" alt="img" />
                <span>题库</span>
            </p>
            <p v-if="false" @click="changeType(typeEnums[8])" class="item wode last" :class="{'active': select === typeEnums[8]}">
                <img crossOrigin="anonymous" class="one" :src="$images.types.weixuanzhongwode" alt="" />
                <img crossOrigin="anonymous" class="two" :src="$images.types.xuanzhongwode" alt="" />
            </p>
            <p class="item empty"> </p>
        </div>
        <div class="guide-more"
            @mouseenter="isGuideBox = true"
            @mouseleave="isGuideBox = false"
        >
            <img slot="reference" :src="$images.guide.guide" alt="img" />
            <GuideBox v-if="isGuideBox" />
            <div
                class="tishiyu"
                :class="{
                    show: isTishiyu
                }"
            >
                <p class="word one">我在这里，老师有需要您还可以找我，</p>
                <p class="word two">重复体验引导练习哦~ 下次见！</p>
            </div>
        </div>
        <div
            class="is-show"
            :class="{
                'show':isShow,
                'deep-black': !isShow?true:select !== typeEnums[11]
            }"
            :style="isQuestionBank && isShow?`left: ${-dragValue-dragArticleValue}px;`:''"
            >
            <div class="more-boxshadow"></div>
            <div class="more-boxshadow2"></div>
            <div class="drag-open">
                <div v-if="isDragZhezhao" id="drag-zhezhao"></div>
                <span
                    id="drag-block"
                    class="drag-block"
                    :style="isQuestionBank && isShow?'':'display:none;'"
                    @mousedown="isDragDown = true"
                    @click.stop
                >
                  <span class="block" :style="dragPopTop?`top: ${dragPopTop}px;`:''">
                      <span class="info">鼠标移至题库列表边界，出现拉伸图标， 可进行拉伸</span>
                  </span>
                </span>
                <span
                    class="iconfont"
                    @click="handleIsShow"
                >
                    <span class="more">
                        <span class="iconfont icon-jiantouxiangyou"></span>
                    </span>
                </span>
            </div>
            <div
                    class="detail"
                    :class="{
                        'show': isShow
                    }"
                    :style="isQuestionBank && show?`width: ${dragValue+dragArticleValue}px;`:''"
            >
                <div v-if="isShow" class="box-shadow"></div>
                <Moshi v-if="select === typeEnums[0]" :show.sync="isShow" @onMoreBtn="moreShow(typeEnums[0])" />
                <Changjing
                        v-if="select === typeEnums[1]"
                        :show.sync="isShow"
                        :navId.sync="navId"
                        @onMoreBtn="moreShow(typeEnums[1], $event)" />
                <Wenzi v-if="select === typeEnums[2]" :show.sync="isShow" @onMoreBtn="moreShow(typeEnums[2])" />
                <Tupian v-if="select === typeEnums[3]" :show.sync="isShow" @onMoreBtn="moreShow(typeEnums[3])" />
                <Yinpin v-if="select === typeEnums[4]" :show.sync="isShow" @onMoreBtn="moreShow(typeEnums[4])" @closeBackAudio="$emit('closeBackAudio')" />
                <Donghua v-if="select === typeEnums[5]" :show.sync="isShow" @onMoreBtn="moreShow(typeEnums[5])" />
                <Shipin v-if="select === typeEnums[6]" :show.sync="isShow" @onMoreBtn="moreShow(typeEnums[6])" />
                <Youxi v-if="select === typeEnums[7]" :show.sync="isShow" @onMoreBtn="moreShow(typeEnums[7])" />
                <Tools v-if="select === typeEnums[10]" :show.sync="isShow" @onMoreBtn="moreShow(typeEnums[10])" />
                <QuestionBank
                    v-if="isQuestionBank"
                    ref="questionBank"
                    :dragValue.sync="dragValue"
                    :show.sync="isShow"
                    :isArticleCatalog.sync="isArticleCatalog"
                    @onMoreBtn="moreShow(typeEnums[11])"
                    @onFeedBack="$emit('onFeedBack', $event)"
                />
            </div>
        </div>
        <More
            :visible.sync="isMore"
            :type.sync="moreType"
            :navId.sync="newNavId"
        />
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import Moshi from './components/moshi'
    import Changjing from './components/changjing'
    import Wenzi from './components/wenzi'
    import Tupian from './components/tupian'
    import Yinpin from './components/yinpin'
    import Donghua from './components/donghua'
    import Shipin from './components/shipin'
    import Youxi from './components/youxi'
    import Tools from './components/tools'
    import QuestionBank from './components/questionBank'
    import More from './components/more'
    import GuideBox from './components/guideBox'
    import { AudioPause } from "../../../../utils/audio";

    export default {
        name: "types",
        components: {
            Moshi,
            Changjing,
            Wenzi,
            Tupian,
            Yinpin,
            Donghua,
            Shipin,
            Youxi,
            More,
            Tools,
            QuestionBank,
            GuideBox
        },
        props: {
            show: {
                type: Boolean,
                defalse: false,
            },
            selected: {
                type: String,
                default: ''
            },
            // 导航id
            navId: [String, Number]
        },
        watch: {
            'guideStep': {
                handler(vl, old){
                    if(old !== 'initial' && vl === 'done'){
                        this.isTishiyu = true

                        const fn = setTimeout(()=>{
                            this.isTishiyu = false
                            clearTimeout(fn)
                        }, 3000)
                    }
                },
                deep: true,
                immediate: true
            },
            dragValue(){
                this.$refs.questionBank &&
                this.$refs.questionBank.calcQuestionTypeHeight &&
                this.$refs.questionBank.calcQuestionTypeHeight()
            },
            isArticleCatalog(vl){
                if(vl){
                    this.dragArticleValue = 463
                }else{
                    this.dragArticleValue = 114
                }
            },
            selected(vl){this.select = vl},
            select(vl){this.$emit('update:selected', vl)},
            show(vl){this.isShow = vl},
            isShow(vl){this.$emit('update:show', vl)},
            '$store.getters.curIsGame': {
                handler(vl){
                    if(vl && !['game'].includes(this.select)){
                       this.isShow = false
                    }
                },
                deep: true,
                immediate: true
            },
            isMore: {
                handler(vl){
                    if(vl){
                        this.setSendKeyBoardToCocos({key: 'isMoreType', value: false})
                    }else{
                        this.setSendKeyBoardToCocos({key: 'isMoreType', value: true})
                    }
                    if(!vl) {
                        AudioPause()
                    }
                },
                deep: true,
                immediate: true
            }
        },
        computed: {
            ...mapState(['guideStep']),
            // 当前选中是否是【题库】
            isQuestionBank(){
                return this.select === this.typeEnums[11]
            },
            // 类型
            typeEnums(){
                return [
                    'template',
                    'scenes',
                    'word',
                    'image',
                    'audio',
                    'animation',
                    'video',
                    'game',
                    'me',
                    'gameScenes',
                    'tools',
                    'questionBank'
                ]
            }
        },
        mounted(){
            this.$nextTick(()=>{
                let div = document.getElementById('drag-block')
                this.dragBox(div)
            })
            window.addEventListener('resize',()=>{
                this.dragValue = 330
            })
        },
        data(){
            return {
                isGuideBox: false, // 是否显示个人信息
                isDragZhezhao: false, // 拖拽遮罩
                isDragDown: false, // 拖拽按钮是否被按下
                dragValue: 330, // 拖拽差值
                isArticleCatalog: false, // 展开文章目录
                dragArticleValue: 114, // 全部展开为 463
                select: this.selected, // 选中类型
                isShow: this.show, // 是否展开
                isMore: false, // 是否更多
                moreType: '', // 更多 - 类型
                newNavId: '', // 导航id
                dragPopTop: 0, // 气泡提示随鼠标移动 上下移动

                isTishiyu: false
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos']),
            // 拖拽
            dragBox(drag) {
                let body = document.body

                const self = this

                drag.addEventListener("mousedown", function () {
                    self.dragable = true;
                    self.isDragZhezhao = true
                }, false);

                let wrapLeft = 0
                document.addEventListener("mousedown", function () {
                    if(self.isDragDown){
                        wrapLeft = 516 + (self.isArticleCatalog?330:0)
                        console.log('left2==>', wrapLeft)
                    }
                }, false);

                document.addEventListener("mousemove", function (e) {
                    self.dragPopTop = e.clientY - 55
                    if (self.isDragDown === true) {
                        e.preventDefault()

                        let nowX = e.clientX,
                            disX = (body.clientWidth - nowX - wrapLeft) + 330
                        console.log('disX==>', disX)

                          if(disX <= 330) disX = 330
                        if(disX >= body.clientWidth - 536 - 400) disX = body.clientWidth - 536 - 400
                        self.dragValue = disX
                    }
                    // 如果超出边界停止滑动
                    if(self.dragValue<330 || self.dragValue>body.clientWidth - 536 - 400){
                        self.isDragDown = false
                        self.isDragZhezhao = false
                    }
                });

                document.addEventListener("mouseup", function () {
                    self.isDragDown = false
                    self.isDragZhezhao = false
                }, false);

            },
            moreShow(type, obj){
                console.log('更多==>', type, obj)
                this.moreType = type
                this.isMore = true

                // 导航id设置 场景需要导航过滤
                if(obj && obj.navId)this.newNavId = obj.navId
            },
            changeType(type){
                this.select = type
                this.isArticleCatalog = false
                this.isShow = true

                // 当选中非音频，默认先关一次音乐
                if(!['audio'].includes(type)){
                    AudioPause()
                }
            },
            handleIsShow(){
                if(['second'].includes(this.guideStep)) return false
                // 如果是游戏且不在游戏类别，禁止展开
                // if(!this.isShow && !this.select){
                //     this.$message.warning('您未选择类型')
                //     return false
                // }
                this.isShow = !this.isShow
                if(!this.select){
                    this.select = 'word'
                }
            },
            handleMouseEnterOpen(){
                this.$store.state.menusKeyBoard=false;//当前是可操作焦点
            },
        }
    }
</script>
<style lang="scss" scoped>
.types-box{
    width: 56px;
    min-width: 56px;
    height: 100%;
    position: relative;
    z-index: 99;

    .types{
        display: flex;
        flex-direction: column;
        align-items: center;
        /*padding-top: 27px;*/
        height: 100%;
        overflow-y: auto;
        position: relative;
        z-index: 20;
        background-color: white;

        .empty{
            width: 100%;
            height: 62px;
        }

        .item{
            width: 100%;
            padding-top: 8px;
            padding-bottom: 2px;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            transition: all .2s linear;
            flex-shrink: 0;
            cursor: pointer;
            position: relative;
            .hot{
                width:13px;
                height:14px;
                position: absolute;
                top:4px;
                left: 18px;
                z-index: 100;
            }
            .iconfont{
                font-size: 20px;
            }

            .name{
                font-size: 14px;
                margin-top: 4px;
                font-weight: 300;
            }
            .one{
                cursor: pointer;
            }
            .two{
                display: none;
                cursor: pointer;
            }
            span{
                margin-top:1px;
                width:100%;
                height:30px;
                line-height: 30px;
                text-align: center;
                color:#8C8F97;
                font-size: 12px;
            }
            img{
                width:22px;
                transition: all 0.3s ease-out 0s;
                -webkit-transition: all 0.3s ease-out 0s;
            }

            &.active{
                background-color: #e7622e;

                .one{display: none}
                .two{display: initial}
                img{
                    width:32px;
                }
                .hot{
                    left:0px;
                }
                .iconfont,
                .name{
                    color: white;
                    font-weight: 400;
                }
                span{
                    color:#ffffff;
                }
            }
            &.disabled {
                cursor: not-allowed;
            }

            &.last{
                margin-bottom: 60px;
            }
        }
    }
    .is-show{
        position: absolute;
        left: 0px;
        top: 0px;
        transition: all .2s linear;
        z-index: 1000;
        height: calc(100vh - 55px);
        align-items: center;
        justify-content: center;
        display: flex;

        .more-boxshadow{
            position: absolute;
            top: 0px;
            left: -38px;
            height: calc((100vh - 55px)/2 - 96px / 2);
            width: 38px;
            background: url("../../../../assets/images/resource/global/shadow3.png") repeat;
            pointer-events: none;
        }

        .more-boxshadow2{
            position: absolute;
            top: calc((100vh - 55px)/2 - 88px / 2 + 72px) ;
            left: -38px;
            height: calc((100vh - 55px)/2 - 88px / 2 + 10px);
            width: 38px;
            background: url("../../../../assets/images/resource/global/shadow3.png") repeat;
            pointer-events: none;
        }

        .drag-open{
            display: flex;
            position: absolute;
            left: -32px;
            height: calc(100vh - 55px);
            flex-direction: column;
            justify-content: center;
            z-index: 2000;

            .more{
                position: absolute;
                top: -48px;
                left: 4px;
                width: 31px;
                height: 100px;
                background: url("../../../../assets/images/resource/global/more.png") no-repeat;
            }

            .block{
                width: 6px;
                height: 20px;
                /*background: wheat;*/
                position: absolute;
                top: 0px;
                left: 0px;
                z-index: 2001;
                display: none;

                .info{
                    font-size: 14px;
                    font-weight: 600;
                    color: #303133;
                    line-height: 20px;
                    position: absolute;
                    top: -28px;
                    left: -300px;
                    width: 252px;
                    height: 42px;
                    padding: 8px 14px;
                    background: #FFFFFF;
                    border: 2px solid #303133;
                    border-radius: 5px;
                    z-index: 2005;

                    &:before{
                        position: absolute;
                        top: 20px;
                        right: -8px;
                        content: '';
                        width: 0px;
                        height: 0px;
                        border-top: 8px solid transparent;
                        border-left: 10px solid white;
                        border-bottom: 8px solid transparent;
                        z-index: 2002;
                    }
                    &:after{
                        position: absolute;
                        top: 20px;
                        right: -11px;
                        content: '';
                        width: 0px;
                        height: 0px;
                        border-top: 8px solid transparent;
                        border-left: 10px solid #303133;
                        border-bottom: 8px solid transparent;
                        z-index: 2001;
                    }
                }
            }

            &>.iconfont {
                display: inline-block;
                font-size: 53px;
                color: white;
                left: -3px;
                top: 0px;
                position: relative;
                cursor: pointer;
                position: relative;
                z-index: 1999;

                .icon-jiantouxiangyou{
                    position: absolute;
                    left: 18px;
                    top: 44px;
                    color: #333333;
                    font-size: 12px;
                    transform: scale(1) rotateZ(180deg);
                }
            }
        }

        .drag-block{
            position: absolute;
            top: 0;
            right: -34px;
            width: 10px;
            height: calc(100vh - 55px);
            /*background-color: wheat;*/
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: ew-resize;
            user-select: none;
            z-index: 1998;

            &:hover .block{
                display: inline-block;
            }
        }

        .btn{
            cursor: pointer;
            width: 33px;
            height: 59px;
        }

        &.show{
            left: -300px;
            #drag-zhezhao{
                position: fixed;
                left: 0px;
                top: 0px;
                width: 100vw;
                height: 100vh;
                z-index: 997;
                /*background-color: rgba(0,0,0,.1);*/
            }

            .iconfont{

                .icon-jiantouxiangyou{
                    transform: scale(1) rotateZ(0deg);
                }
            }
        }
    }
    .detail{
        width: 0px;
        /*position: absolute;*/
        top: 0px;
        right: 66px;
        height: 100%;
        z-index: 1001;
        background-color: white;
        transition: width .2s linear;
        overflow: hidden;

        .box-shadow{
            position: absolute;
            top: 0px;
            right: 0px;
            height: calc(100vh - 55px);
            width: 16px;
            background: url("../../../../assets/images/resource/global/shadow1.png") repeat;
            z-index: 10;
            pointer-events: none;
        }
    }
    .detail{
        &.show {
            width: 296px;
            border-right: 2px solid #f0f0f0;
            z-index: 2001;
        }
    }

    .guide-more{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 0px;
        z-index: 100;
        height: 62px;
        background: #393B42;

        .tishiyu{
            display: none;
            position: absolute;
            bottom: 17px;
            left: -290px;
            width: 279px;
            height: 86px;
            background: #FFFFFF;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
            border-radius: 6px;

            &.show{
                display: block;
            }

            .word{
                font-size: 14px;
                font-weight: 400;
                color: #303133;
                line-height: 24px;
                margin-left: 18px;

                &.one{
                    margin-top: 19px;
                }
                &.two{
                    color: #FF7838;
                }
            }
        }
    }
    &.deep-black{
        position: relative;
        .types{
            background-color: #222328;

            .item.active{
                background-color: #393B42;
            }
        }
        .is-show.deep-black{
            .detail{
                background-color: #26282E;
                border-color: #26282E;
            }
            .more-boxshadow,
            .more-boxshadow2{
                display: none;
            }
            .drag-open{
                .more{
                    left: 18px;
                    width: 18px;
                    height: 90px;
                    background: url("../../../../assets/images/resource/global/yousousuo.svg");

                    .icon-jiantouxiangyou{
                        color: white;
                        left: 3px;
                        top: 38px;
                    }
                }
            }
            &.show{
                .more .icon-jiantouxiangyou{
                    left: 4px;
                }
            }
        }

        .detail.show {
            width: 300px;

            .box-shadow {
                display: none;
            }
        }
    }
}
@media screen and (max-height: 850px) {
    .types-box {
        width: 72px;
        min-width: 72px;

        .detail{
            right: 71px;
        }
    }
}

@media (min-height: 860px) {
    .types-box{
        .types{
            .item{
                padding-top: 14px;
                .hot{
                    top:8px;
                    left: 12px;
                }
            }
        }
    }
}
@media (min-height: 990px) {
    .types-box{
        .types{
            .item{
                width: 100%;
                padding-top: 16px;
                padding-bottom: 8px;
                span{
                    font-size:14px;
                }
            }
        }
    }
}
</style>
